import {storesApiClient} from "@/configuration/api-client";
import { SESSION_STORAGE_USER_RIGHTS_KEY, UserRights } from "@/configuration/authentication";
import { UserDetailsResponse } from "@/model/user/UserDetailsResponse";
import { Service } from "vue-typedi";
import authentication from "@/configuration/authentication";

@Service()
export class UserService {

    private static readonly USERS_ENDPOINT: string = '/users';

    public getUserDetails(identifier: string, storeId: string): Promise<UserDetailsResponse>{
        return storesApiClient.get(UserService.USERS_ENDPOINT + "/details", {params: { id : identifier, storeId: storeId }})
            .then((response: any) => {
                const data: UserDetailsResponse = response && response.data ? response.data : {};
                return Promise.resolve(data);
            }).catch(error => {
                return Promise.reject(error);
            })
    }

    public updateUserDetails(userDetails: UserDetailsResponse, storeId: string): Promise<UserDetailsResponse> {
        return storesApiClient.put(UserService.USERS_ENDPOINT + "/details", userDetails,{params: { storeId: storeId }})
            .then((response: any) => {
                const data: UserDetailsResponse = response && response.data ? response.data : {};
                return Promise.resolve(data);
        }).catch(error => {
            return Promise.reject(error);
        });
    }

    public getUserRights(): Promise<UserRights>{
        const data: string = sessionStorage.getItem(SESSION_STORAGE_USER_RIGHTS_KEY);
        if(!data){
            return this.loadUserRights();
        }
        return Promise.resolve(<UserRights> JSON.parse(data));
    }

    public loadUserRights(): Promise<UserRights>{
        return authentication.loadUserRights();
    }
}
